export const questionType = [
  { value: 'single', label: 'Single Answer' },
  { value: 'multiple', label: 'Multiple Answers' },
  { value: 'essay', label: 'Essay' }
];
